import {showSessionExpiredPrompt} from 'components/genericComponents/SessionExpiredPrompt';
import {selectHasUnsavedWork} from 'store/unsavedWorkSlice';
import {redirectToLoginWhenActive} from 'utils/autoLogin';

/**
 * Called when a mid-session silent token refresh fails. Editors with
 * registered unsaved work get a non-blocking reconnect prompt instead of
 * losing their in-progress content to a hard redirect.
 */
export const handleReauthFailure = (getState) => {
  if (!selectHasUnsavedWork(getState())) {
    redirectToLoginWhenActive();
    return;
  }
  showSessionExpiredPrompt();
};
